import { PaginationQueryParams } from '@forwardflow/types'
import { create } from 'zustand'

type State = PaginationQueryParams

type Action = {
   setQueryParams: (updatedParams: State) => void
   resetPagination: () => void
}

export const userOrganizationUsersForInvitationFilter = create<Action & State>()((set) => ({
   page: 1,
   sorts: '',
   fields: '',
   filters: '',
   search: '',
   limit: 10,
   includes: '',
   setQueryParams: (updatedParams) =>
      set((state) => ({
         ...state,
         ...updatedParams,
      })),
   resetPagination: () =>
      set(() => ({
         page: 1,
         sorts: '',
         fields: '',
         filters: '',
         search: '',
         limit: 10,
         includes: '',
      })),
}))